module.exports = __webpack_public_path__ + "static/media/bold.ea1c6431.svg";